import { Checkbox, VStack } from '@genial/components';
import React from 'react';

import { FixedFeeAvailableConfigs } from '../../../../../../../store/fixedFee/types';

interface ExclusionItemProps {
  excludeEquity: boolean;
  onChange: (value: boolean) => void;
  availableConfigs?: FixedFeeAvailableConfigs;
  loadingAvailableRateRanges: boolean;
}

export const ExclusionItem: React.FC<ExclusionItemProps> = ({
  excludeEquity,
  onChange,
  availableConfigs,
  loadingAvailableRateRanges,
}) => {
  const optionValue = 'excludeEquity';

  return (
    <VStack>
      <Checkbox
        testId="exclude-equity-checkbox"
        selectedValues={excludeEquity ? [optionValue] : []}
        onChange={() => onChange(!excludeEquity)}
        options={[
          {
            label: 'Exclusão de cobranças sobre renda variável',
            value: optionValue,
            disabled: !availableConfigs?.ableToExcludeEquity || loadingAvailableRateRanges,
          },
        ]}
      />
    </VStack>
  );
};
